var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    className: "header-icon m-2",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.6,78.6v103.4H27.9V44.2l24.4-24.4h82.8c1.1-2.2,2.6-4.2,4.6-6H51c-.8,0-1.6.3-2.1.9l-26.1,26.1c-.6.6-.9,1.3-.9,2.1v142.1c0,1.7,1.3,3,3,3h121.7c1.7,0,3-1.3,3-3v-107.7c-1.9.8-3.9,1.2-6,1.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,45.9h-26.1c-1.2,0-2.3-.7-2.8-1.9-.5-1.1-.2-2.4.7-3.3l26.1-26.1c.9-.9,2.1-1.1,3.3-.7,1.1.5,1.9,1.6,1.9,2.8v26.1c0,1.7-1.3,3-3,3ZM32.1,39.9h15.9v-15.9l-15.9,15.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.3,83.5c-19.7,0-35.8-16.1-35.8-35.8s16.1-35.8,35.8-35.8,35.8,16.1,35.8,35.8-16.1,35.8-35.8,35.8ZM142.3,18.8c-15.9,0-28.9,13-28.9,28.9s13,28.9,28.9,28.9,28.9-13,28.9-28.9-13-28.9-28.9-28.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.5,59.2c-1.2,0-2.3-.7-2.7-1.8l-6.8-15.8-15.8,6.8c-1.5.7-3.3,0-3.9-1.6-.7-1.5,0-3.3,1.6-3.9l18.5-8c.7-.3,1.6-.3,2.3,0,.7.3,1.3.9,1.6,1.6l8,18.5c.7,1.5,0,3.3-1.6,3.9-.4.2-.8.2-1.2.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,154.9c-.4,0-.8,0-1.2-.3-1.5-.7-2.2-2.4-1.5-3.9l15.7-35.9c.7-1.5,2.4-2.2,3.9-1.5,1.5.7,2.2,2.4,1.5,3.9l-15.7,35.9c-.5,1.1-1.6,1.8-2.7,1.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.3,131.9c-.8,0-1.7-.4-2.3-1l-12.8-14.9c-1.1-1.3-.9-3.1.3-4.2,1.2-1.1,3.1-.9,4.2.3l12.8,14.9c1.1,1.3.9,3.1-.3,4.2-.6.5-1.3.7-2,.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.8,106.1c-.8,0-1.7-.4-2.3-1l-13.3-15.3c-1.1-1.2-.9-3.1.3-4.2,1.2-1.1,3.1-.9,4.2.3l13.3,15.3c1.1,1.2.9,3.1-.3,4.2-.6.5-1.3.7-2,.7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.3,131.9c-.4,0-.8,0-1.2-.3-1.5-.7-2.2-2.4-1.5-3.9l17.2-39.3c.7-1.5,2.4-2.2,3.9-1.5,1.5.7,2.2,2.4,1.5,3.9l-17.2,39.3c-.5,1.1-1.6,1.8-2.7,1.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.8,106.1c-.4,0-.8,0-1.2-.2-1.5-.6-2.2-2.4-1.6-3.9l27.5-65.3c.6-1.5,2.4-2.2,3.9-1.6,1.5.6,2.2,2.4,1.6,3.9l-27.5,65.3c-.5,1.1-1.6,1.8-2.8,1.8Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.7,119.8c-5.9,0-11.1-4.3-12-10.3-1-6.6,3.6-12.8,10.2-13.8,6.6-1,12.8,3.6,13.8,10.2h0c1,6.6-3.6,12.8-10.2,13.8-.6,0-1.2.1-1.8.1ZM57.7,101.5c-.3,0-.6,0-.9,0-3.3.5-5.7,3.6-5.2,7,.5,3.3,3.6,5.7,7,5.2,3.3-.5,5.7-3.6,5.2-7h0c-.5-3-3.1-5.2-6.1-5.2Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.6,93c-5.9,0-11.1-4.3-12-10.3-1-6.6,3.6-12.8,10.2-13.8,3.2-.5,6.4.3,9,2.2,2.6,1.9,4.3,4.7,4.8,7.9h0c1,6.6-3.6,12.8-10.2,13.8-.6,0-1.2.1-1.8.1ZM98.6,74.7c-.3,0-.6,0-.9,0-3.3.5-5.7,3.6-5.2,7,.5,3.3,3.6,5.7,7,5.2,3.3-.5,5.7-3.6,5.2-7-.2-1.6-1.1-3.1-2.4-4-1.1-.8-2.3-1.2-3.6-1.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressGraphIcon);
export default __webpack_public_path__ + "static/media/progress-graph-icon.7ef7fe56f8f18bc2992b5addcc1285c6.svg";
export { ForwardRef as ReactComponent };